import { InputEntity } from "../../..";

export class TransmedRegistrationFieldValidationInput extends InputEntity {
  public constructor(
    public quantity: number,
    public answer: string | null,
    public valid: boolean
  ) {
    super();
  }
}

export class TransmedRegistrationFieldValidationCreateInput extends InputEntity {
  public constructor(public field: number, public registration: number) {
    super();
  }
}
